module.exports = __webpack_public_path__ + "img/mada.f5ef2492.svg";